import httpClient from './httpClient'

const
	apiAuthenticate = (val) => httpClient.post(process.env.VUE_APP_BASE_URL + '/auth/local', val),
	apiGetUser = () => httpClient.get(process.env.VUE_APP_BASE_URL + '/users/me')

export {
	apiAuthenticate,
	apiGetUser
}